const dynamicFederation = async (scope, module) => {
  try {
    console.log(`[dynamicFederation] Attempting to load module "${module}" from container "${scope}"`);
    
    let container;
    let attempts = 0;
    const maxAttempts = 50;
    
    // Lista todos os containers disponíveis no window para debug
    const availableContainers = Object.keys(window).filter(key => 
      window[key] && typeof window[key] === 'object' && 
      (window[key].get || window[key].init)
    );
    console.log(`[dynamicFederation] Available containers in window:`, availableContainers);
    
    while (!container && attempts < maxAttempts) {
      container = window[scope];

      if (!container) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
        
        if (attempts % 10 === 0) {
          console.log(`[dynamicFederation] Waiting for container "${scope}"... (attempt ${attempts}/${maxAttempts})`);
        }
      }
    }

    if (!container) {
      const errorMsg = `Container "${scope}" not found after ${maxAttempts} attempts. Available containers: ${availableContainers.join(', ')}`;
      console.error(`[dynamicFederation] ${errorMsg}`);
      throw new Error(errorMsg);
    }

    console.log(`[dynamicFederation] Container "${scope}" found, initializing...`);

    if (!container.__initialized) {
      if (!__webpack_share_scopes__ || !__webpack_share_scopes__.default) {
        console.warn(`[dynamicFederation] __webpack_share_scopes__.default not available, initializing container without shared scope`);
        // Alguns containers podem não precisar de init, ou podem ter sua própria lógica
        if (container.init) {
          try {
            await container.init(__webpack_share_scopes__?.default || {});
          } catch (initError) {
            console.warn(`[dynamicFederation] Error during container init (may be expected):`, initError);
          }
        }
      } else {
        await container.init(__webpack_share_scopes__.default);
      }
      container.__initialized = true;
      console.log(`[dynamicFederation] Container "${scope}" initialized`);
    } else {
      console.log(`[dynamicFederation] Container "${scope}" already initialized`);
    }

    const candidates = [];
    if (typeof module === 'string') {
      candidates.push(module);
      if (!module.startsWith('./')) {
        candidates.push(`./${module}`);
      }
      if (module === './GuestHeader') {
        candidates.push('./HeaderDisconnected', './header');
      }
      if (module === './HeaderDisconnected') {
        candidates.push('./GuestHeader', './header');
      }
      if (module === './header') {
        candidates.push('./GuestHeader', './HeaderDisconnected');
      }
      if (module === './GuestFooter') {
        candidates.push('./FooterDisconnected', './footer');
      }
      if (module === './FooterDisconnected') {
        candidates.push('./GuestFooter', './footer');
      }
      if (module === './footer') {
        candidates.push('./GuestFooter', './FooterDisconnected');
      }
    } else {
      candidates.push(module);
    }
    const unique = [...new Set(candidates)];

    let factory;
    let usedPath;
    let lastError;

    for (const path of unique) {
      try {
        console.log(`[dynamicFederation] Getting module "${path}" from container "${scope}"`);
        factory = await container.get(path);
        if (factory) {
          usedPath = path;
          break;
        }
      } catch (e) {
        lastError = e;
        console.warn(`[dynamicFederation] get("${path}") failed:`, e?.message || e);
      }
    }

    if (!factory) {
      const errorMsg = `Module "${module}" does not exist in container "${scope}" (tried: ${unique.join(', ')}). Reinicie o build do MFE (solutions) para gerar remoteEntry com os exposes atuais.`;
      console.error(`[dynamicFederation] ${errorMsg}`, lastError);
      throw new Error(errorMsg);
    }

    console.log(`[dynamicFederation] Module "${usedPath}" factory obtained, creating module instance`);
    const Module = factory();

    console.log(`[dynamicFederation] Successfully loaded module "${module}" from container "${scope}"`);
    return Module;
  } catch (error) {
    console.error(`[dynamicFederation] Error loading module "${module}" from container "${scope}":`, error);
    throw error;
  }
};

export default dynamicFederation;

